module.exports = __webpack_public_path__ + "static/img/bar.c96da66.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/smart/bar.png
// module id = UZ3R
// module chunks = 0 2